'use client';

import type { ReactNode } from 'react';
import { use } from 'react';

import { ClaimQuestPage } from './claim-quest';

interface QuestIdLayoutProps {
  children: ReactNode;
  params: Promise<{
    subdomain: string;
    questId: string;
    moduleId: string;
  }>;
}

export default function QuestDetailLayoutClient(props: QuestIdLayoutProps) {
  const params = use(props.params);

  const { subdomain, questId, moduleId } = params;

  const { children } = props;

  return (
    <div className="flex flex-row gap-100 w-full">
      <ClaimQuestPage {...{ subdomain, questId, moduleId }} />
      {children}
    </div>
  );
}
